import { gql } from '@apollo/client';

export const CREATE_CONTACT_REQUEST = gql`
  mutation ($contactRequestAnswer: CreateContactRequestAnswerInput!) {
    createContactRequestAnswer(input: $contactRequestAnswer) {
      contactRequestAnswer {
        status
      }
    }
  }
`;

export const CREATE_NET_PROMOTER_SCORE = gql`
  mutation ($npsScore: NetPromoterScoreInput) {
    createNetPromoterScore(npsScore: $npsScore) {
      success
      error {
        __typename
        ... on ValidationErrors {
          validationErrors {
            field
            messages
          }
        }
      }
    }
  }
`;
